export default __webpack_public_path__ + "static/media/bathroom-main-category.32612a23.jpeg";